import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  customerCode: {
    name: "customerCode",
    label: "Customer Code",
    type: "text",
    errorMsg: "Customer code is required.",
    required: true,
    editable: false,
    maxLength: 20,
  },
  companyCode: {
    name: "companyCode",
    label: "Company Code",
    type: "select",
    errorMsg: "Company code is required.",
    required: true,
  },
  customerName: {
    name: "customerName",
    label: "Customer Name",
    type: "text",
    errorMsg: "Customer name is required.",
    required: true,
    maxLength: 100,
    size: 3,
  },
  custShortName: {
    name: "custShortName",
    label: "Customer Short Name",
    type: "text",
    errorMsg: "Customer short name is required.",
    required: true,
    size: 3,
  },
  customerType: {
    name: "customerType",
    label: "Customer Type",
    type: "select",
    required: true,
  },
  registrationNo: {
    name: "registrationNo",
    label: "Registration No",
    type: "text",
  },
  companyLogo: {
    name: "companyLogo",
    label: "Company Logo",
    type: "text",
  },
  companyUrl: {
    name: "companyUrl",
    label: "Company Website",
    type: "text",
    size: 3,
  },
  // currencyCode: {
  //   name: "currencyCode",
  //   label: "Currency Code",
  //   type: "select",
  //   size:6,
  //   required: true,
  // },

  billCompany: {
    name: "billCompany",
    label: "Company",
    type: "text",
    errorMsg: "Billing company is required.",
    required: true,
  },
  billAddress1: {
    name: "billAddress1",
    label: "Address1",
    type: "text",
    errorMsg: "Billing address1 is required.",
    required: true,
  },
  billAddress2: {
    name: "billAddress2",
    label: "Address2",
    type: "text",
    errorMsg: "Billing address2 is required.",
    required: true,
  },
  billPostcode: {
    name: "billPostcode",
    label: "Postcode",
    type: "text",
    errorMsg: "Billing postcode is required.",
    required: true,
  },
  billCity: {
    name: "billCity",
    label: "City",
    type: "text",
    errorMsg: "Billing city is required.",
    required: true,
  },
  billState: {
    name: "billState",
    label: "State",
    type: "text",
    errorMsg: "Billing state is required.",
    required: true,
  },
  billCountry: {
    name: "billCountry",
    label: "Country",
    type: "select",
    errorMsg: "Billing country is required.",
    required: true,
  },
  billPhoneNo: {
    name: "billPhoneNo",
    label: "Phone No",
    type: "text",
    errorMsg: "Billing phone no is required.",
    required: true,
  },
  billFaxNo: {
    name: "billFaxNo",
    label: "Fax No",
    type: "text",
  },

  shipCompany: {
    name: "shipCompany",
    label: "Company",
    type: "text",
    errorMsg: "Shipping company is required.",
    required: true,
  },
  shipAddress1: {
    name: "shipAddress1",
    label: "Address1",
    type: "text",
    errorMsg: "Shipping address1 is required.",
    required: true,
  },
  shipAddress2: {
    name: "shipAddress2",
    label: "Address2",
    type: "text",
    errorMsg: "Shipping address2 is required.",
    required: true,
  },
  shipPostcode: {
    name: "shipPostcode",
    label: "Postcode",
    type: "text",
    errorMsg: "Shipping postcode is required.",
    required: true,
  },
  shipCity: {
    name: "shipCity",
    label: "City",
    type: "text",
    errorMsg: "Shipping city is required.",
    required: true,
  },
  shipState: {
    name: "shipState",
    label: "State",
    type: "text",
    errorMsg: "Shipping state is required.",
    required: true,
  },
  shipCountry: {
    name: "shipCountry",
    label: "Country",
    type: "select",
    errorMsg: "Shipping country is required.",
    required: true,
  },
  shipPhoneNo: {
    name: "shipPhoneNo",
    label: "Phone No",
    type: "text",
    errorMsg: "Shipping phone no is required.",
    required: true,
  },
  shipFaxNo: {
    name: "shipFaxNo",
    label: "Fax No",
    type: "text",
  },

  contactPerson: {
    name: "contactPerson",
    label: "Contact Person",
    type: "text",
    errorMsg: "Contact person name is required.",
    required: true,
  },
  contactPhoneNo: {
    name: "contactPhoneNo",
    label: "Phone No",
    type: "text",
    errorMsg: "Phone no is required.",
    required: true,
  },
  contactMobileNo: {
    name: "contactMobileNo",
    label: "Mobile No",
    type: "text",
    errorMsg: "Mobile no is required.",
    required: true,
  },
  contactEmail: {
    name: "contactEmail",
    label: "Email",
    type: "text",
  },

  apiSecretKey: {
    name: "apiSecretKey",
    label: "API Secret Key",
    type: "text",
  },
  integrateETrax: {
    name: "integrateETrax",
    label: "eTrax Integration",
    type: "switch",
    default: false,
  },
  useSerialNbr: {
    name: "useSerialNbr",
    label: "Outbound Serial Number Enabled",
    type: "switch",
    default: false,
  },
  useInbSerialNbr: {
    name: "useInbSerialNbr",
    label: "Inbound Serial Number Enabled",
    type: "switch",
    default: false,
    size: 3,
  },
  useBackOrder: {
    name: "useBackOrder",
    label: "Allow Backorder",
    type: "switch",
    default: false,
  },
  allowPartialRecv: {
    name: "allowPartialRecv",
    label: "Allow Partial Receiving",
    type: "switch",
    default: false,
  },
  multiParcel: {
    name: "multiParcel",
    label: "Multi Parcel Enabled",
    type: "switch",
    default: false,
    size:3
  },
  usePackingMaterial: {
    name: "usePackingMaterial",
    label: "Packing Material Enabled",
    type: "switch",
    default: false,
    size:3
  },
  preferredCarrier:{
    name:"preferredCarrier",
    label:"Preferred Carrier",
    type:"select"
  },
  fulfillInDays: {
    name: "fulfillInDays",
    label: "Fulfill In Days",
    type: "number",
    size: 3,
  },
  defOrderType: {
    name: "defOrderType",
    label: "Default Order Type",
    type: "select",
    size: 3,
  },
  orderShelfLife: {
    name: "orderShelfLife",
    label: "Order Shelf Life",
    type: "number",
    size: 3,
  },
  applyBilling: {
    type: "button",
    name: "applyBilling",
    label: "Apply Billing",
  },
  defPickingType: {
    name: "defPickingType",
    label: "Picking Type",
    type: "select",
    size: 3,
  },
};

const {
  registrationNo,
  customerCode,
  companyCode,
  customerName,
  customerType,
  custShortName,
  companyUrl,
  // currencyCode,
  companyLogo,
  billCompany,
  billAddress1,
  billAddress2,
  billPostcode,
  billCity,
  billState,
  billCountry,
  billPhoneNo,
  billFaxNo,
  shipCompany,
  shipAddress1,
  shipAddress2,
  shipPostcode,
  shipCity,
  shipState,
  shipCountry,
  shipPhoneNo,
  shipFaxNo,
  contactPerson,
  contactPhoneNo,
  contactMobileNo,
  contactEmail,
  apiSecretKey,
  integrateETrax,
  useSerialNbr,
  useInbSerialNbr,
  useBackOrder,
  allowPartialRecv,
  multiParcel,
  usePackingMaterial,
  preferredCarrier,
  fulfillInDays,
  defOrderType,
  orderShelfLife,
  applyBilling,
  defPickingType
} = formField;

export const formRender = [
  [customerCode, companyCode, customerType, registrationNo],
  [customerName, custShortName, companyUrl,preferredCarrier],
  // [currencyCode],
  [
    { type: "title", label: "Billing Address" },
    { type: "title", label: "Shipping Address" },
  ],
  [billCompany, billCity, shipCompany, shipCity],
  [billAddress1, billState, shipAddress1, shipState],
  [billAddress2, billCountry, shipAddress2, shipCountry],
  [billPostcode, billPhoneNo, shipPostcode, shipPhoneNo],
  [billFaxNo, applyBilling, shipFaxNo, ""],
  [{ type: "title", label: "Contact Info" }],
  [contactPerson, contactMobileNo, contactPhoneNo, contactEmail],
  [{ type: "title", label: "Process Control" }],
  [apiSecretKey, defOrderType, fulfillInDays, orderShelfLife],
  [useBackOrder, integrateETrax, useSerialNbr, allowPartialRecv],
  [multiParcel, usePackingMaterial, useInbSerialNbr, defPickingType],
];

export const initialValues = getInitialValues(formField);

export const customerValidations = Yup.object().shape({
  [customerCode.name]: Yup.string().max(20).required(customerCode.errorMsg),
  [companyCode.name]: Yup.string().max(20).required(companyCode.errorMsg),
  [customerName.name]: Yup.string().max(100).required(customerName.errorMsg),
  [customerType.name]: Yup.string().max(20).required(customerType.errorMsg),
  [custShortName.name]: Yup.string().max(30).required(custShortName.errorMsg),
  // [currencyCode.name]: Yup.string().max(30).required(currencyCode.errorMsg),
  [billCompany.name]: Yup.string().max(100).required(billCompany.errorMsg),
  [billAddress1.name]: Yup.string().max(200).required(billAddress1.errorMsg),
  [billAddress2.name]: Yup.string().max(200).required(billAddress2.errorMsg),
  [billPostcode.name]: Yup.string().max(10).required(billPostcode.errorMsg),
  [billCity.name]: Yup.string().max(100).required(billCity.errorMsg),
  [billState.name]: Yup.string().max(100).required(billState.errorMsg),
  [billCountry.name]: Yup.string().max(100).required(billCountry.errorMsg),
  [billPhoneNo.name]: Yup.string().max(20).required(billPhoneNo.errorMsg),
  [billFaxNo.name]: Yup.string().nullable().max(20),
  [shipCompany.name]: Yup.string().max(100).required(shipCompany.errorMsg),
  [shipAddress1.name]: Yup.string().max(200).required(shipAddress1.errorMsg),
  [shipAddress2.name]: Yup.string().max(200).required(shipAddress2.errorMsg),
  [shipPostcode.name]: Yup.string().max(20).required(shipPostcode.errorMsg),
  [shipCity.name]: Yup.string().max(100).required(shipCity.errorMsg),
  [shipState.name]: Yup.string().max(100).required(shipState.errorMsg),
  [shipCountry.name]: Yup.string().max(100).required(shipCountry.errorMsg),
  [shipPhoneNo.name]: Yup.string().max(20).required(shipPhoneNo.errorMsg),
  [shipFaxNo.name]: Yup.string().nullable().max(20),
  [contactPerson.name]: Yup.string().max(100).required(contactPerson.errorMsg),
  [contactMobileNo.name]: Yup.string().max(20).required(contactMobileNo.errorMsg),
  [contactPhoneNo.name]: Yup.string().max(20).required(contactPhoneNo.errorMsg),
});
